import { COUPON_EXCH_INFO } from '@/config';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { ref, onUnmounted, onMounted } from '@vue/composition-api';
import dayjs from 'dayjs';

export const useCouponLock = () => {
  // 锁 计时器相关
  const isLock = ref(true);
  const clock = ref(0); // 计时器
  // 计时器逻辑处理
  const handleClock = () => {
    const serverTimeMills = getServerTime().getTime();
    const today = dayjs(serverTimeMills).format('YYYY/MM/DD');
    // 兑换开始时间（12：00：00）
    const couponExchStartTimeVal = dayjs(`${today} ${COUPON_EXCH_INFO.couponExchStartTime}`).valueOf();
    // 兑换结束时间（23：59：59）
    const couponExchEndTimeVal = dayjs(`${today} ${COUPON_EXCH_INFO.couponExchEndTime}`).valueOf();
    // 是否在锁定时间内
    isLock.value = serverTimeMills < couponExchStartTimeVal || serverTimeMills > couponExchEndTimeVal;
  };
  const checkCleareClock = () => {
    if (clock.value) {
      clearInterval(clock.value);
      clock.value = 0;
    }
  };
  const clearClock = () => {
    console.log('关闭计时器', dayjs().format('HH:mm:ss'));
    checkCleareClock();
  };

  const startClock = () => {
    checkCleareClock();

    // 开始计时之前先调用一次
    handleClock();

    console.log('开始计时器', dayjs().format('HH:mm:ss'));
    clock.value = setInterval(() => handleClock(), 1000);
  };
  onMounted(() => {
    startClock();
  });
  onUnmounted(() => {
    // 清空计时器
    clearClock();
  });
  return {
    isLock,
  };
};
